import 'react-select/dist/react-select.css';
import 'react-virtualized/styles.css';
import 'react-virtualized-select/styles.css';
import React from 'react';
import * as R from 'ramda';
import VirtualizedSelect from 'react-virtualized-select';
import {FormLabel} from 'js/form_components';

function buildOnChange(props) {
    return function(val) {
        if (R.isEmpty(val)) {
            props.onChange(null);
        } else {
            props.onChange(val);
        }
    };
}

const InputSelect = (props) => {
    const options = R.map(R.pick(['value', 'label']), props.options || []);
    const disabled = R.isNil(props.disabled) ? false : props.disabled;

    return (
        <div className="form-group">
            <FormLabel
                className={props.className}
                label={props.header}
                helpText={props.help}
                place="right"
                multiline
                inline
            />
            <VirtualizedSelect
                disabled={disabled}
                name={props.name}
                multi={props.multiSelect}
                value={props.value}
                clearable={props.clearable}
                options={options}
                loadOptions={props.loadOptions}
                async={!R.isNil(props.loadOptions)}
                onChange={buildOnChange(props)}
            />
            { props.extras || null }
        </div>
    );
};

export default InputSelect;



// WEBPACK FOOTER //
// ./publisher_leads/advanced_filters/input_select.js